module.exports = __webpack_public_path__ + "img/svg/explain-2.9ab6394df4fa6a248dc70fc3d4dc9318.svg";